import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors";

interface Props {
  content: string;
  link: string;
  variant?: "h2" | "h3" | "h4";
  topAnchorScrollPadding?: boolean;
}

const getHeadlineStyle = (variant: string) => {
  if (variant === "h4") {
    return {
      marginBottom: "-12px",
      fontSize: "18px",
      lineHeight: "22px",
      fontWeight: "500",
      color: Colors.TextSecondary,
    };
  } else if (variant === "h3") {
    return {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "500",
      color: Colors.TextDark,
    };
  } else {
    return {
      fontSize: "32px",
      lineHeight: "38px",
      fontWeight: "600",
      color: Colors.TextDark,
    };
  }
};

const Headline: FC<Props> = ({
  content,
  link,
  variant = "h2",
  topAnchorScrollPadding = false,
}) => {
  const textStyle = getHeadlineStyle(variant);

  return (
    <Stack
      mb={3}
      id={link}
      sx={{
        scrollMarginTop: topAnchorScrollPadding ? "80px" : "",
      }}
    >
      <Typography variant={variant} sx={textStyle}>
        {content}
      </Typography>
    </Stack>
  );
};

export default Headline;
